import React from "react"
import { ELanguage } from "../../../../models"
interface IProps {
    lang: ELanguage
    order: number | string
    title: string
    body: string
}
interface IState {

}

export default class QuestHTMLViewer extends React.Component<IProps, IState> {
    private identifier
    constructor(props) {
        super(props)
        this.identifier = `${props.lang}-${props.order}`
    }

    componentDidMount() {
        const questionViewer = document.getElementById(this.identifier)
        questionViewer.innerHTML = this.props.body
    }

    render() {
        return (
            <div style={{ paddingRight: 20, paddingLeft: 20 }}>
                <div style={{ fontSize: 12 }}>
                    {this.props.title}
                </div>
                <div id={this.identifier} style={{ fontSize: 17 }} />
                <hr />
            </div>
        )
    }
}